import ArrowIcon from '~/assets/icons/Arrow';

export default function NotificationTooltip({
  className
}: {
  className?: string;
}) {
  return (
    <div
      className={`flex h-8 items-center justify-between bg-purple-hola-super-light p-2 md:py-1.5 ${className}`}
    >
      <div className="text-xs leading-3 text-purple-hola">
        Tap the bell to get a release alert
      </div>
      <div className="rotate-270">
        <ArrowIcon fill="#8907e7" />
      </div>
    </div>
  );
}
